import { render, staticRenderFns } from "./ChemUBC154PLQ6.vue?vue&type=template&id=6c325d58&scoped=true&"
import script from "./ChemUBC154PLQ6.vue?vue&type=script&lang=js&"
export * from "./ChemUBC154PLQ6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c325d58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCheckbox,VForm,VImg})
